import {EDITABLE_COMPONENTS} from '../../../../constants/surveys';

export const getInitialValues = (
    components
) => {
  const initialValues = {};
  components
      .filter((item) => item.type === EDITABLE_COMPONENTS[item.type])
      .map((item) => {
        if (item.required) {
          initialValues[item.id] = '';
        }
      });

  return initialValues;
};
